import { render } from "./ProductListComponent.vue?vue&type=template&id=656bb764"
import script from "./ProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/ProductListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "656bb764"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('656bb764', __exports__)) {
    api.reload('656bb764', __exports__)
  }
  
  module.hot.accept("./ProductListComponent.vue?vue&type=template&id=656bb764", () => {
    api.rerender('656bb764', render)
  })

}


export default __exports__